export const unblockScreenShare = () => {
    const fakeEvent = new Event('unhandledrejection');
    fakeEvent.reason = { name: 'NotAllowedError' };
    window.dispatchEvent(fakeEvent);
};
export const unblockAutoPlay = () => {
    const options = {};
    if (navigator.mediaDevices.getSupportedConstraints().sampleRate) {
        options.sampleRate = 48000;
    }
    const anyWindow = window;
    anyWindow.wixLiveVideoAudioContext = new (anyWindow.AudioContext || anyWindow.webkitAudioContext)(options);
    anyWindow.wixLiveVideoAudioContext.resume();
    document.createElement('audio').play();
};
export const unblockSoundIOS = () => {
    return document.querySelector('#wix-amazon-audio').play();
};
//# sourceMappingURL=amazon-hacks.js.map